import { IStore } from '../../index'

export default function(state: IStore) {
  return state.userAccount.user.userTime
}

export function getUserDateOffset(state: IStore) {
  return state.userAccount.user.userOffset
}
